
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developers",
      function () {
        return require("private-next-pages/developers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developers"])
      });
    }
  